import styles from './insuranceWarning.module.scss';

export type InsuranceWarningBreed = {
  name?: string | null;
  size?: string | null;
  healthProblems?: string[] | null;
  sizeHealthProblems?: string[] | null;
};

export type InsuranceWarningProps = {
  breed?: InsuranceWarningBreed | string | null;
};

const normalizeProblems = (breed: InsuranceWarningBreed | null) => {
  const fromBreed = Array.isArray(breed?.healthProblems)
    ? breed?.healthProblems
    : [];
  if (fromBreed.length > 0) return fromBreed;
  return Array.isArray(breed?.sizeHealthProblems)
    ? breed?.sizeHealthProblems
    : [];
};

export const InsuranceWarning = ({ breed }: InsuranceWarningProps) => {
  const resolved = typeof breed === 'object' && breed ? breed : null;
  const problems = normalizeProblems(resolved);

  const boldLabel = resolved?.name
    ? resolved.name
    : resolved?.size
      ? `${resolved.size}s`
      : 'Dogs';

  return (
    <div className={styles.insuranceWarning}>
      <div className={styles.header}>
        <span className={styles.icon} aria-hidden="true">
          !
        </span>
        <div className={styles.headerText}>
          <span className={styles.bold}>{boldLabel}</span>
          <span className={styles.description}>
            are most likely to have these health problems:
          </span>
        </div>
      </div>
      <div className={styles.content}>
        <ul className={styles.list}>
          {problems.map((problem, index) => (
            <li key={`problem-${index}`} className={styles.listItem}>
              {problem}
            </li>
          ))}
        </ul>
        <div className={styles.footerText}>
          Paction strongly recommends that you consider pet health insurance
        </div>
      </div>
    </div>
  );
};

export default InsuranceWarning;
